export const refillCardConfirmMessages = () => {
  const createBothChangedMessage = (
    originalPrice: number,
    originalTotalVisits: number,
    originalPricePerVisit: number,
    newPrice: number,
    newTotalVisits: number,
    newPricePerVisit: number
  ) => (
    <div>
      <p>
        <strong>Внимание!</strong> Променихте и цената, и броя посещения.
      </p>
      <p>
        Текуща логика: {originalPrice} лв за {originalTotalVisits} посещения ={" "}
        {originalPricePerVisit.toFixed(2)} лв/посещение
      </p>
      <p>
        Нова логика: {newPrice} лв за {newTotalVisits} посещения ={" "}
        {newPricePerVisit.toFixed(2)} лв/посещение
      </p>
      <p>Сигурни ли сте, че искате да продължите?</p>
    </div>
  );

  const createPriceChangedMessage = (
    originalPricePerVisit: number,
    newPricePerVisit: number
  ) => (
    <div>
      <p>
        <strong>Внимание!</strong> Променяте цената на плана.
      </p>
      <p>
        Това ще промени финансовата логика. Всяко посещение вече ще струва{" "}
        <strong>{newPricePerVisit.toFixed(2)} лв</strong> вместо{" "}
        <strong>{originalPricePerVisit.toFixed(2)} лв</strong>.
      </p>
      <p>Сигурни ли сте, че искате да продължите?</p>
    </div>
  );

  const createVisitsChangedMessage = (
    originalPrice: number,
    originalTotalVisits: number,
    originalPricePerVisit: number,
    newTotalVisits: number,
    newPrice: number,
    newPricePerVisit: number,
    adjustedPrice: number
  ) => (
    <div>
      <p>
        <strong>Внимание!</strong> Променяте броя посещения.
      </p>
      <p>
        Текуща логика: {originalPrice} лв за {originalTotalVisits} посещения ={" "}
        {originalPricePerVisit.toFixed(2)} лв/посещение
      </p>
      <p>Нов общ брой посещения (за плана): {newTotalVisits}</p>
      <hr style={{ margin: "10px 0" }} />
      <p>
        <strong>
          Искате ли цената да бъде автоматично коригирана, за да запази същата
          стойност на посещение?
        </strong>
      </p>
      <p>
        • ДА: Общата заплатена цена на плана ще стане{" "}
        {adjustedPrice.toFixed(2)}лв ({newTotalVisits} ×{" "}
        {originalPricePerVisit.toFixed(2)}лв)
      </p>
      <p>
        • НЕ: Общата заплатена цена на плана остава {newPrice}лв (всяко
        посещение ще струва {newPricePerVisit.toFixed(2)}лв)
      </p>
    </div>
  );

  return {
    createBothChangedMessage,
    createPriceChangedMessage,
    createVisitsChangedMessage,
  };
};
